import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';
var CubeComponent = /** @class */ (function () {
    function CubeComponent(cubeService, toastr, ngbDataConv, vcr) {
        this.cubeService = cubeService;
        this.toastr = toastr;
        this.ngbDataConv = ngbDataConv;
        this.vcr = vcr;
        this.pageNo = 0;
        this.pageSize = 10;
        this.totalCubes = 0;
        this.sPage = 0;
        this.cubeReg = '';
        this.lastRegex = '';
        this.cubeData = { id: null, name: '', description: '', deleted: 0, dataSourceId: null };
        this.mainPage = true;
        this.cubePage = false;
        this.datePicker = false;
        this.currentPage = 1;
        this.startingPage = 0;
        this.endingPage = 0;
        this.entityOpsFlag = false;
        this.cubeList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.dataSourceList = [];
        this.isEdit = false;
        this.dimensionList = [];
        this.recordList = [];
        this.recordObject = {};
        this.measureList = [];
        this.measIndex = -1;
        this.dimInd = -1;
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap = new Map();
        this.filteredDimensionMap = new Map();
        this.measurePage = false;
        this.dimensionPage = false;
        this.dataVersionType = '';
        this.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        this.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none', name: null,
            recordFormatField: null, cubeId: null, deleted: 0
        };
        this.cubeDimensionUsageList = [];
        this.referencevariable = 'none';
        this.loader = false;
        this.totalPages = 0;
        this.dataVersionDate = { day: null, month: null, year: null };
        this.toastr.setViewRef(vcr);
    }
    CubeComponent.prototype.ngOnInit = function () {
        if (this.cubeService.isBIAdmin) {
            this.loadCube();
        }
        else {
            this.accessDenied = true;
        }
    };
    CubeComponent.prototype.entityOps = function (event) {
        if (this.selectedCubeId == null) {
            this.selectedCubeId = event.target.id;
        }
        else {
            this.selectedCubeId = null;
        }
    };
    CubeComponent.prototype.closeDropDown = function (event) {
        this.selectedCubeId = null;
    };
    CubeComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.cubeReg != '') {
            this.searchPCube();
        }
        else {
            this.loadCube();
        }
        this.setEndingPage(this.totalCubes);
    };
    CubeComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalCubes / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadCube();
    };
    CubeComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    CubeComponent.prototype.loadCube = function () {
        var _this = this;
        var self = this;
        return new Promise(function (resolve) {
            self.loader = true;
            _this.cubeService.getDataByPage(BiUrls.CUBE, self.pageNo, self.pageSize).then(function (res) {
                self.cubeList = [];
                self.totalCubes = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.cubeList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements : [];
                    self.totalCubes = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.parseDataVersionDates();
                self.setEndingPage(self.totalCubes);
                self.loader = false;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    CubeComponent.prototype.parseDataVersionDates = function () {
        var self = this;
        for (var _i = 0, _a = self.cubeList; _i < _a.length; _i++) {
            var cb = _a[_i];
            cb.dataVersion = new Date(cb.dataVersion);
        }
    };
    // By Lalu
    CubeComponent.prototype.searchPCube = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.mainPage = true;
            self.loader = true;
            self.cubeList = [];
            if (self.cubeReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.cubeReg;
            var resu = self.cubeService.search(BiUrls.CUBE, BiUrls.SEARCH_P_CUBE, self.cubeReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPCube(res);
                self.loader = false;
            }, function (err) {
                console.error(err);
            });
            resolve('completed');
        });
    };
    // By Lalu
    CubeComponent.prototype.loadSearchedPCube = function (res) {
        var self = this;
        self.cubeList = (res != undefined) ? res.data.pageElements : [];
        self.totalCubes = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalCubes);
    };
    CubeComponent.prototype.loadRecordFormat = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.cubeService.onStartUp(BiUrls.RECORDFORMAT).then(function (res) {
                self.recordList = res.data;
                self.loadMeasures();
                self.loadDimensions();
                resolve('completed');
            });
        });
    };
    CubeComponent.prototype.loadDimensions = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.cubeService.onStartUp(BiUrls.DIMENSION).then(function (res) {
                self.dimensionList = res != undefined && res.data != undefined ? res.data : [];
                for (var _i = 0, _a = self.dimensionList; _i < _a.length; _i++) {
                    var d = _a[_i];
                    var _loop_1 = function (cdu) {
                        if (d.id == cdu.dimensionId) {
                            var filtered = d.dimHierarchyData[0]
                                .dimHierarchyLevelData.filter(function (item) { return cdu.dimHierarchyLevelData && (cdu.dimHierarchyLevelData.id == item.id); });
                            for (var _i = 0, filtered_1 = filtered; _i < filtered_1.length; _i++) {
                                var lvl = filtered_1[_i];
                                self.filteredDimensionMap.set(lvl.id, lvl);
                                self.dimInd = d.dimHierarchyData[0]
                                    .dimHierarchyLevelData.indexOf(lvl);
                                d.dimHierarchyData[0]
                                    .dimHierarchyLevelData.splice(self.dimInd, 1);
                            }
                            //d.dimHierarchyData[0].dimHierarchyLevelData = filtered;
                        }
                    };
                    for (var _b = 0, _c = self.cubeDimensionUsageList; _b < _c.length; _b++) {
                        var cdu = _c[_b];
                        _loop_1(cdu);
                    }
                }
                resolve('completed');
            });
        });
    };
    CubeComponent.prototype.loadMeasures = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.cubeService.onStartUp(BiUrls.MEASURE).then(function (res) {
                self.measureList = res != undefined && res.data != undefined ? res.data : [];
                for (var _i = 0, _a = self.cubeMeasureDataList; _i < _a.length; _i++) {
                    var cm = _a[_i];
                    for (var _b = 0, _c = self.measureList; _b < _c.length; _b++) {
                        var m = _c[_b];
                        if (m.id == cm.measureId) {
                            self.filteredMeasureMap.set(m.id, m);
                            self.measIndex = self.measureList.indexOf(m);
                            self.measureList.splice(self.measIndex, 1);
                        }
                    }
                }
                resolve('completed');
            });
        });
    };
    CubeComponent.prototype.addNewCube = function () {
        console.log('On Add Controller ...');
        var self = this;
        self.mainPage = false;
        self.cubePage = true;
        this.cubeData = { id: null, name: '', description: null, dataSourceId: '', deleted: 0 };
    };
    CubeComponent.prototype.onSave = function () {
        console.log('On Save Controller ...');
        var self = this;
        self.processDataVersion('save');
        var validate = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            self.saveButton = true;
            self.loader = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.cubeService.update(BiUrls.CUBE, self.cubeData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self.cubeService.save(BiUrls.CUBE, self.cubeData).then(function (res) {
                    console.log(self.pageNo);
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    };
    CubeComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalCubes / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            this.totalPages;
        self.currentPage = self.pageNo + 1;
        var text = type == 'new' ? 'Cube saved successfully' : 'Changes saved successfully';
        if (self.cubeReg != '') {
            self.searchPCube().then(function (res) {
                self.loaderAfterSaveOrUpdate();
            });
        }
        else {
            self.loadCube().then(function (res) {
                self.loaderAfterSaveOrUpdate();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else if (result.status != 500) {
                    self.toastr.showError(result.statusText);
                }
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    CubeComponent.prototype.loaderAfterSaveOrUpdate = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.cubePage = false;
        self.isEdit = false;
        self.cubeMeasureDataList = [];
        self.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        self.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null,
            recordFormatFieldId: 'none', recordFormatField: null, cubeId: null, deleted: 0
        };
        self.referencevariable = 'none';
        self.cubeDimensionUsageList = [];
        self.loader = false;
    };
    CubeComponent.prototype.clickEdit = function (cubeData) {
        var self = this;
        self.loader = true;
        self.selectedCubeId = null;
        self.cubeService.getDataById(BiUrls.CUBE, cubeData.id).then(function (res) {
            console.log(res.data);
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load Cube');
                self.mainPage = true;
            }
            else {
                self.loadRecordFormat();
                self.isEdit = true;
                self.mainPage = false;
                self.cubePage = true;
                self.cubeData = JSON.parse(JSON.stringify(res.data));
                self.processDataVersion('edit');
                console.log(self.cubeData);
                self.cubeMeasureDataList = self.cubeData.cubeMeasureData;
                self.cubeDimensionUsageList = self.cubeData.cubeDimensionUsageData;
                if (self.cubeData.recordFormatId != undefined &&
                    self.cubeData.recordFormatId != null) {
                    self.recordFormatId = self.cubeData.recordFormatId;
                    self.onSelectRecord(self.cubeData.recordFormatId);
                }
                else {
                    self.recordFormatId = 'none';
                }
                delete self.cubeData.schema;
                delete self.cubeData.facts;
                delete self.cubeData.schemaName;
                delete self.cubeData.status;
                delete self.cubeData.factNames;
                delete self.cubeData.dataSourceName;
            }
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
    };
    CubeComponent.prototype.onBack = function () {
        this.referencevariable = 'none';
        this.mainPage = true;
        this.cubePage = false;
        this.selectedCubeId = null;
        this.isEdit = false;
        this.recordObject = {};
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap.clear();
        this.filteredDimensionMap.clear();
        this.cubeDimensionUsageList = [];
        this.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        this.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0
        };
    };
    CubeComponent.prototype.delete = function (cube, removeDim, removeMeasure) {
        var self = this;
        self.loader = true;
        self.cubeService.delete(BiUrls.CUBE, cube.id + "/" + removeDim + "/" + removeMeasure).then(function (response) {
            self.toastr.showSuccess(cube.name + ' removed successfully');
            self.pageNo = self.cubeList.length == 1 ? self.totalCubes == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadCube();
            self.loader = false;
        }, function (err) {
            self.toastr.showError('Unable to remove Cube : ' + err.errorCode);
        });
    };
    CubeComponent.prototype.removeCube = function (cube) {
        var r = confirm('Are you sure you want to delete the cube ' + cube.name + '?');
        if (r == true) {
            this.delete(cube, 0, 0);
        }
    };
    CubeComponent.prototype.removeCubeWithDimsAndMeasures = function (cube) {
        var r = confirm('Are you sure you want to delete the cube ' + cube.name + ' along with dimensions and measures associated with it?');
        if (r == true) {
            this.delete(cube, 1, 1);
        }
    };
    CubeComponent.prototype.validater = function () {
        if (this.cubeData.name == undefined || this.cubeData.name.trim() == '') {
            return 'Please enter the name for cube';
        }
        else {
            this.cubeData.name = this.cubeData.name.trim();
            this.cubeData.description = this.cubeData.description != undefined ?
                this.cubeData.description.trim() : null;
            this.cubeData.recordFormatId = this.recordFormatId == 'none' ? null
                : this.recordFormatId;
            this.cubeData.cubeMeasureData = this.cubeMeasureDataList;
            this.cubeData.cubeDimensionUsageData = this.cubeDimensionUsageList;
            return '';
        }
    };
    CubeComponent.prototype.onSelectRecord = function (id) {
        var _this = this;
        var self = this;
        self.recordFormatId = id;
        return new Promise(function (resolve) {
            _this.cubeService.getObjectById(BiUrls.RECORDFORMAT + '/' + self.recordFormatId).then(function (res) {
                self.recordObject = res.data;
                if (self.recordObject.dataSourceData) {
                    self.cubeData['dataSourceData'] = self.recordObject.dataSourceData;
                }
                else {
                    delete self.cubeData['dataSourceData'];
                }
            }, function (err) {
                delete self.cubeData['dataSourceData'];
            });
            resolve('completed');
        });
    };
    CubeComponent.prototype.confirmChangeOfRecordFormat = function (event) {
        var r = this.recordFormatId == 'none' ? true :
            confirm('Are you sure you want to change the Record Format? ' +
                'It will erase all the Mappings of Measure and Dimension.');
        if (r) {
            this.cubeDimensionUsageList = [];
            this.cubeMeasureDataList = [];
            this.recordObject = {};
            delete this.cubeData['dataSourceData'];
            if (event.target.value != 'none') {
                this.toastr.showSuccess(this.recordFormatId == 'none' ? 'Record Format added' :
                    'Record Format changed');
                this.onSelectRecord(event.target.value);
            }
            else {
                this.toastr.showWarning('Record Format removed');
                this.recordFormatId = 'none';
            }
        }
        else {
            event.target.value = this.recordFormatId;
        }
    };
    CubeComponent.prototype.onSelectMeasure = function (event) {
        for (var _i = 0, _a = this.measureList; _i < _a.length; _i++) {
            var measure = _a[_i];
            if (measure.id == Number(event.target.value)) {
                this.cubeMeasureData['measureData'] = measure;
                this.filteredMeasureMap.set(measure.id, measure);
                this.measIndex = this.measureList.indexOf(measure);
            }
        }
    };
    CubeComponent.prototype.onSelectDimenasion = function (event) {
        var ids = event.target.value.split('_');
        for (var _i = 0, _a = this.dimensionList; _i < _a.length; _i++) {
            var dim = _a[_i];
            if (dim.id == Number(ids[0])) {
                for (var _b = 0, _c = dim.dimHierarchyData[0].dimHierarchyLevelData; _b < _c.length; _b++) {
                    var levels = _c[_b];
                    if (levels.id == Number(ids[1])) {
                        this.cubeDimensionUsageData['dimensionData'] = dim;
                        this.cubeDimensionUsageData['dimensionId'] = dim.id;
                        this.cubeDimensionUsageData['dimHierarchyLevelId'] = levels.id;
                        this.cubeDimensionUsageData['dimHierarchyLevelData'] = levels;
                        this.filteredDimensionMap.set(levels.id, levels);
                        this.dimInd = dim.dimHierarchyData[0].dimHierarchyLevelData.indexOf(levels);
                        this.selectedDim = dim;
                        //dim.dimHierarchyData[0].dimHierarchyLevelData.splice(index, 1);
                    }
                }
            }
        }
    };
    CubeComponent.prototype.onSelectField = function (event, param) {
        for (var _i = 0, _a = this.recordList; _i < _a.length; _i++) {
            var record = _a[_i];
            if (record.id == this.recordFormatId && record.recordFormatFieldData != undefined) {
                for (var _b = 0, _c = record.recordFormatFieldData; _b < _c.length; _b++) {
                    var field = _c[_b];
                    if (field.id == Number(event.target.value)) {
                        if (param == 'measure') {
                            this.cubeMeasureData['recordFormatField'] = field;
                        }
                        else {
                            this.cubeDimensionUsageData['recordFormatField'] = field;
                        }
                    }
                }
            }
        }
    };
    CubeComponent.prototype.addFieldForMeasure = function () {
        var validate = this.validaterMeasureRecordFormat();
        if (validate != '') {
            this.toastr.showError(validate);
            console.error(validate);
        }
        else {
            this.measureList.splice(this.measIndex, 1);
            this.cubeMeasureData.cubeId = this.cubeData.id;
            this.cubeMeasureDataList.push(this.cubeMeasureData);
            this.cubeMeasureData = {
                measureId: 'none', measureData: null, recordFormatFieldId: 'none',
                recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
            };
            this.toastr.showSuccess('Measure linked');
            this.measIndex = -1;
        }
    };
    CubeComponent.prototype.addFieldForDimension = function () {
        var validate = this.validaterDimensionRecordFormat();
        if (validate != '') {
            this.toastr.showError(validate);
            console.error(validate);
        }
        else {
            this.selectedDim.dimHierarchyData[0].dimHierarchyLevelData.splice(this.dimInd, 1);
            this.cubeDimensionUsageData.cubeId = this.cubeData.id;
            this.cubeDimensionUsageList.push(this.cubeDimensionUsageData);
            this.cubeDimensionUsageData = {
                dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none',
                recordFormatField: null, cubeId: null, deleted: 0
            };
            this.toastr.showSuccess('Dimension linked');
        }
        this.referencevariable = 'none';
    };
    CubeComponent.prototype.removeCubeMeasure = function (event, cubeMeasure) {
        var r = confirm('Are you sure you want to remove this field ' +
            cubeMeasure.measureData.name + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Linking of measure removed successfully');
            this.measureList.push(this.filteredMeasureMap.get(cubeMeasure.measureData.id));
            var index = this.cubeMeasureDataList.indexOf(cubeMeasure);
            this.cubeMeasureDataList.splice(index, 1);
        }
    };
    CubeComponent.prototype.removeCubeDimension = function (event, cubeDimension) {
        var r = confirm('Are you sure you want to remove this field ' +
            cubeDimension.dimHierarchyLevelData.displayName + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Linking of dimension removed successfully');
            console.log(cubeDimension);
            var dimIndex = this.dimensionList.indexOf(cubeDimension.dimensionData);
            for (var _i = 0, _a = this.dimensionList; _i < _a.length; _i++) {
                var d = _a[_i];
                if (d.id == cubeDimension.dimensionId) {
                    d.dimHierarchyData[0].dimHierarchyLevelData.push(this.filteredDimensionMap.get(cubeDimension.dimHierarchyLevelId));
                }
            }
            var index = this.cubeDimensionUsageList.indexOf(cubeDimension);
            this.cubeDimensionUsageList.splice(index, 1);
        }
    };
    CubeComponent.prototype.validaterMeasureRecordFormat = function () {
        if (this.cubeMeasureData.measureId == 'none' ||
            this.cubeMeasureData.recordFormatFieldId == 'none') {
            return 'Please select both measure and record format field to add';
        }
        else {
            return '';
        }
    };
    CubeComponent.prototype.validaterDimensionRecordFormat = function () {
        if (this.cubeDimensionUsageData['dimensionId'] == 'none' ||
            this.cubeDimensionUsageData['recordFormatFieldId'] == 'none') {
            return 'Please select both dimension and record format field to add';
        }
        else {
            return '';
        }
    };
    CubeComponent.prototype.editMeasure = function (cubeMeasure) {
        this.cubePage = false;
        this.measurePage = true;
        this.measureData = cubeMeasure.measureData;
    };
    CubeComponent.prototype.comingBackFromMeasureScreen = function () {
        this.cubePage = true;
        this.measurePage = false;
        this.openMeasureMapping = "measure";
        this.openDimensionMapping = '';
    };
    CubeComponent.prototype.afterSavingMeasure = function (event) {
        var self = this;
        this.cubePage = true;
        this.measurePage = false;
        this.cubeMeasureDataList.forEach(function (measure) {
            if (measure.measureData.id == event.data.id) {
                measure.measureData = event.data;
            }
        });
        this.openMeasureMapping = "measure";
        this.openDimensionMapping = '';
    };
    CubeComponent.prototype.afterSavingDimension = function (event) {
        var self = this;
        this.cubePage = true;
        this.dimensionPage = false;
        this.cubeDimensionUsageList.forEach(function (dim) {
            if (dim.dimensionData.id == event.data.id) {
                dim.dimensionData = event.data;
            }
        });
        this.openDimensionMapping = 'dimension';
        this.openMeasureMapping = '';
    };
    CubeComponent.prototype.comingBackFromDimensionScreen = function () {
        this.openDimensionMapping = 'dimension';
        this.openMeasureMapping = '';
        this.cubePage = true;
        this.dimensionPage = false;
    };
    CubeComponent.prototype.editDimension = function (cubeMeasure) {
        this.cubePage = false;
        this.dimensionPage = true;
        this.dimensionData = cubeMeasure.dimensionData;
    };
    CubeComponent.prototype.clearCacheForCube = function (cube) {
        var self = this;
        self.cubeService.clearCache('ads/clearDataCache/' + cube.id).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess("Cube Cache cleared successfully!");
            }
            else {
                self.toastr.showError("Unable To Clear Cube Cache!");
            }
        });
    };
    CubeComponent.prototype.clearCache = function () {
        var self = this;
        self.cubeService.clearCache('ads/clearDataCache').then(function (res) {
            if (res.success) {
                self.toastr.showSuccess("Cache cleared successfully!");
            }
            else {
                self.toastr.showError("Unable To Clear Cache!");
            }
        });
    };
    CubeComponent.prototype.getTitle = function (type) {
        var self = this;
        if (type == 'measure') {
            return 'Cube Measure Mapping ( ' + self.cubeMeasureDataList.length + ' )';
        }
        else {
            return 'Cube Dimension Mapping ( ' + self.cubeDimensionUsageList.length + ' )';
        }
    };
    CubeComponent.prototype.processDataVersion = function (action) {
        var self = this;
        if (action == 'save') {
            var date = Date.parse(self.ngbDataConv.toModel(self.dataVersionDate));
            self.cubeData.dataVersion = self.dataVersionType == 'Static' ? date : null;
            self.cubeData.dataVersionType = self.dataVersionType;
        }
        else {
            if (self.cubeData.dataVersionType != undefined && self.cubeData.dataVersionType == 'Static') {
                self.dataVersionType = 'Static';
                var dateTime = new Date(self.cubeData.dataVersion);
                var strDate = dateTime.getUTCDate() + '-' +
                    (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
                self.dataVersionDate = self.ngbDataConv.fromModel(strDate);
            }
            else {
                self.dataVersionType = 'Dynamic';
            }
        }
    };
    return CubeComponent;
}());
export { CubeComponent };



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/cube.component.ts.pre-build-optimizer.js